// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  kmlUploadInfoGrid: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 0,
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    columnGap: theme.spacing(1.5),
  },
  imageryRequestCard: {
    border: 'solid 1px #D9DDE1',
    borderTop: '5px solid #FAA738',
    borderRadius: '5px',
    background: '#fff',
    marginTop: 0,
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    padding: theme.spacing(1),
  },
  imageryRequestBarUpdate: {
    borderTop: '5px solid #243FDD',
  },
  imageryRequestContent: {
    padding: theme.spacing(1),
  },
  imageryBottomContent: {
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  submitButton: {
    float: 'right',
    color: '#243FDD',
  },
  imageryInfoContent: {
    display: 'flex',
    alignItems: 'center',
  },
  imageryRequestTitle: {
    display: 'flex',
    alignItems: 'center',
    fontWeight: 400,
    color: '#000',
  },
  imageryRequestTitleText: {
    paddingLeft: '10px',
  },
  imageryRequestDetails: {
    display: 'flex',
    fontSize: 14,
    marginTop: theme.spacing(1),
  },
  buttonProgress: {
    position: 'relative',
    left: '40px',
  },
  checkbox: {
    '&.Mui-disabled': {
      cursor: 'not-allowed',
    },
  },
  imageryRequestActionContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  imageryProcessingButton: {
    float: 'right',
  },
  imageryCoverageLoading: {
    display: 'flex',
    alignItems: 'center',
  },
  imageryCoverageLoadingText: {
    paddingLeft: '15px',
  },
  processingContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 'fit-content',
  },
  uploadYourOwnData: {
    color: '#778791',
    fontSize: '12px',
    fontWeight: 400,
  },
  imageryButton: {
    color: '#243FDD',
  },
  imageryRequestIcon: {
    color: '#FAA738',
    marginRight: '10px',
  },
  imageryRequestIconUpdate: {
    color: theme.palette.primary.main,
    marginRight: '10px',
  },
  imageryRequestControls: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  kmlUploadIcon: {
    height: '36px',
    width: '36px',
  },
  kmlUploadText: {
    fontSize: '12px',
    fontWeight: 400,
  },
  requestImageryButton: {
    padding: 0,
    whiteSpace: 'nowrap' as const,
  },
  anchorTag: {
    color: 'inherit',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  timer: {
    color: theme.palette.primary.main,
    fontWeight: 400,
  },
  processingLabel: {
    fontSize: 12,
    fontWeight: 600,
  },
  checkCoverageButtonWrapper: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  checkCoverageButton: {
    backgroundColor: '#E1EFF4',
    color: theme.palette.primary.main,
    textTransform: 'none',
    fontWeight: 500,
    fontSize: '14px',
    borderRadius: '6px',
    padding: theme.spacing(1),
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#d0e4ec',
      boxShadow: 'none',
    },
  },
  coverageStatusBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(1),
    backgroundColor: '#E8F5E9',
    borderRadius: '6px',
    padding: theme.spacing(0.75, 1.5),
  },
  noCoverageStatusBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(1),
    backgroundColor: '#FF942426',
    borderRadius: '6px',
    padding: theme.spacing(0.75, 1.5),
  },
  coverageStatusContent: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  coverageStatusText: {
    fontSize: '13px',
    fontWeight: 500,
    color: '#2E7D32',
  },
  noCoverageIcon: {
    color: '#FF9424',
    fontSize: 18,
  },
  noCoverageStatusText: {
    fontSize: '13px',
    fontWeight: 500,
    color: '#333',
  },
  coverageActionButton: {
    color: theme.palette.primary.main,
    fontWeight: 600,
    fontSize: '13px',
    textTransform: 'uppercase',
    padding: theme.spacing(0.25, 1),
    minWidth: 'auto',
  },
  reviewButton: {
    color: '#00A1D4',
    fontWeight: 600,
    fontSize: '13px',
    textTransform: 'uppercase',
    padding: theme.spacing(0.25, 1),
    minWidth: 'auto',
  },
  requestDialogContent: {
    padding: theme.spacing(3),
  },
  requestDialogTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(2),
  },
  requestDialogText: {
    fontSize: 14,
    marginBottom: theme.spacing(1),
  },
  requestDialogSubtext: {
    fontSize: 14,
    marginBottom: theme.spacing(2),
  },
  requestDialogActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
  cancelButton: {
    color: '#9E9E9E',
  },
  continueButton: {
    color: theme.palette.primary.main,
  },
});

export default styles;
